import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { LuFacebook, LuInstagram } from 'react-icons/lu';
import {
  CONTACTO,
  BRAND,
  NAV_CATEGORIES,
  ROUTES,
  presupuestoWhatsAppUrl,
} from '../../constants';
import './Footer.css';

function Footer() {
  const [isLoaded, setIsLoaded] = useState(false);
  const waUrl = presupuestoWhatsAppUrl();

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <footer className={`footer ${isLoaded ? 'footer-loaded' : ''}`}>
      <Container fluid="lg" className="footer-body">
        <Row className="gy-4">
          <Col xs={12} md={6} lg={4}>
            <h6 className="footer-title">Empresa</h6>
            <p className="footer-text footer-brand-desc">
              {/* {BRAND.NAME} — {BRAND.TAGLINE}. */}
               Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <NavLink to={ROUTES.CAJAS} className="footer-link">
              Ver productos
            </NavLink>
            <NavLink to={ROUTES.TERMINOS} className="footer-link">
              Términos y condiciones
            </NavLink>
          </Col>

          <Col xs={6} md={6} lg={2}>
            <h6 className="footer-title">Productos</h6>
            {NAV_CATEGORIES.map((cat) => (
              <NavLink key={cat.api} to={cat.path} className="footer-link footer-main">
                {cat.label}
              </NavLink>
            ))}
            <NavLink to={ROUTES.CAJAS} className="footer-link">
              Catálogo completo
            </NavLink>
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="footer-link">
              Pedidos a medida
            </a>
          </Col>

          <Col xs={6} md={6} lg={2}>
            <h6 className="footer-title">Links rápidos</h6>
            <NavLink to={ROUTES.HOME} className="footer-link">
              Inicio
            </NavLink>
            <NavLink to={ROUTES.CAJAS} className="footer-link">
              Productos
            </NavLink>
            <NavLink to={ROUTES.CONTACTO} className="footer-link">
              Contacto
            </NavLink>
            <NavLink to={ROUTES.CARRITO} className="footer-link">
              Carrito
            </NavLink>
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="footer-link">
              Presupuesto
            </a>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <h6 className="footer-title">Contacto</h6>
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="footer-contact-link">
              <p className="footer-contact">
                <FaWhatsapp className="plain-icon" /> {CONTACTO.WHATSAPP_DISPLAY}
              </p>
            </a>
            <a href={`mailto:${BRAND.EMAIL}`} className="footer-contact-link">
              <p className="footer-contact">
                <FaEnvelope className="plain-icon" /> {BRAND.EMAIL}
              </p>
            </a>
            <div className="footer-socials-inline">
              <a
                href={BRAND.INSTAGRAM}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="Instagram"
              >
                <LuInstagram strokeWidth={1.75} />
              </a>
              <a
                href={BRAND.FACEBOOK}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="Facebook"
              >
                <LuFacebook strokeWidth={1.75} />
              </a>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="footer-bottom">
        <Container fluid="lg" className="footer-bottom-inner">
          <div className="footer-left">
            <small className="footer-copy">
              &copy; {new Date().getFullYear()} {BRAND.NAME} · {BRAND.TAGLINE}
            </small>
          </div>
          <div className="footer-right">
            <small className="footer-copy">
              Diseño y desarrollo by{' '}
              <a
                href="http://higherweb.com.ar"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-credit-link"
              >
                Higherweb
              </a>
            </small>
          </div>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
